import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/banner/2.jpg")